import React from "react";

const Checkmark = props => (
  <svg width={10} height={9.6} {...props}>
    <path fill="#fff" d="M3 6.9L1.3 5.2 0 6.5l3 3.1 1.3-1.4L10 2.6V0z" />
  </svg>
);

export default Checkmark;
